import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedPlusSmBoldIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 13, height: 22, viewBox: '0 0 13 22', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M7.156 5.719v4.375h4.375c.356 0 .656.3.656.656 0 .383-.3.656-.656.656H7.156v4.375c0 .383-.3.656-.656.656a.63.63 0 0 1-.656-.656v-4.375H1.469a.63.63 0 0 1-.657-.656c0-.355.274-.656.657-.656h4.375V5.719c0-.356.273-.657.656-.657.355 0 .656.301.656.657' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: '1dc57e9c4427000c5e369c0757837df9__a' },
            React.createElement("path", { d: 'M0 0h13v22H0z' })))));
const ForwardRef = forwardRef(LabelPairedPlusSmBoldIcon);
export default ForwardRef;
